<template>
  <el-container class="main-container">
    <div class="content-wrapper">
      <!-- 顶部导航 -->
      <section>
        <div class="contact-header">
          <div class="header-content">
            <div class="contact-title">{{ t('footerContact') }}</div>
            <el-row class="contact-links">
              <el-col :span="8" class="link-item">
                <router-link to="/ContactUs" class="a-style">{{ t('contactOnline') }}</router-link>
              </el-col>
              <el-col :span="8" class="link-item middle">
                <router-link to="/xiaoshou" class="a-style">{{ t('contactSales') }}</router-link>
              </el-col>
              <el-col :span="8" class="link-item">
                <router-link to="/shouhou" class="a-style">{{ t('contactService') }}</router-link>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="header-image-container">
          <router-link to="/Rwachaxun" class="a-style"><img src="/static/ad5.jpg" class="header-image"></router-link>
        </div>
      </section>

      <section class="contact-content">
        <el-row :gutter="21" type="flex" justify="center" class="content-row">
          <el-col :span="13" class="contact-details" >
            <span class="content-title">{{ t('contactOnline') }}</span><br/><br/><br/><br/>
            <span>{{ t('contactName') }}:{{ contactInfo[0].name }}</span><br/><br/><br/>
            <span>{{ t('contactPhone') }}:{{ contactInfo[0].phone }}</span><br/><br/><br/>
            <span>{{ t('contactAddress') }}:{{ contactInfo[0].address }}</span><br/><br/><br/>
          </el-col>
        </el-row>
      </section>
    </div>
  </el-container>
</template>

<script>
import {listContactInfo} from "@/utils/http";

export default {
  name: "ContactUs",
  props: ['t', 'currentLang'],
  data() {
    return {
      collapsed: false,
      currentLang: 'zh',
      flagCn: 'https://flagcdn.com/w40/cn.png',
      flagEn: 'https://flagcdn.com/w40/gb.png',
      params:{
        eType:0,
        type:1
      },
      contactInfo:[]
    };
  },
  created() {
    this.initContactInfo();
  },
  watch: {
    currentLang(newVal, oldVal) {
      this.onLangChange(newVal);
    }
  },
  methods: {
    onLangChange(lang) {
      if(lang==='zh'){
        this.params.eType=0;
      }else{
        this.params.eType=1;
      }
      this.initContactInfo();
    },
    initContactInfo(){
      listContactInfo(this.params).then(response => {
        this.contactInfo=response.rows;
      })
    }
  }
};
</script>

<style scoped>

/* 基础样式 */
section, div, img {
  margin: 0;
  padding: 0;
}

.a-style {
  text-decoration: none;
  color: inherit;
}

img {
  display: block;
  max-width: 100%;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none !important;
}

.el-menu--horizontal > .el-menu-item:hover {
  border-bottom: none !important;
}

.main-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}

.content-wrapper {
  background-color: #FFFFFF;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}

.contact-header {
  background-color: #1A2029;
  padding: 20px 0;
  color: white;
  width: 100%;
}

.header-content {
  width: 80%;
  max-width: 1600px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  height: 120px;
  align-items: center;
}

.contact-title {
  font-size: 38px;
  font-weight: bold;
  margin-bottom: 15px;
}

.contact-links {
  background-color: white;
  border-radius: 4px;
  overflow: hidden;
  text-align: center;
  width: 40%;
  height: 28px;
  line-height: 3px;
  margin-top: -6px;
  margin-left: 50px;
}

.link-item {
  padding: 12px 0;
  color: #333;
  font-size: 16px;
}

.link-item.middle {
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}

.header-image-container {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}

.header-image {
  width: 100%;
  height: auto;
  display: block;
}

.contact-content {
  background-color: white;
  margin: 0 auto;
  padding: 0;
  color: #000;
  width: 100%;
  max-width: 1920px;
}

.content-row {
  padding-top: 40px;
  padding-bottom: 40px;
  max-width: 1600px;
  margin: 0 auto;
}

.contact-details {
  margin: 0;
  padding: 0;
}

.content-title {
  font-weight: bold;
  font-size: 40px;
}

/* 高分辨率适配 */
@media screen and (min-width: 1921px) {
  .header-image {
    width: 1920px;
    margin: 0 auto;
    display: block;
  }
}

/* 纯移动端样式 - 只在小于768px时生效 */
@media screen and (max-width: 768px) {
  .header-content {
    width: 95%;
    flex-direction: column;
    height: auto;
  }

  .contact-title {
    font-size: 28px;
    margin-bottom: 20px;
    text-align: center;
  }

  .contact-links {
    width: 90%;
    margin: 20px auto 0;
    height: auto;
    line-height: normal;
  }

  .link-item {
    padding: 15px 0;
    font-size: 14px;
  }

  .content-row {
    padding: 20px 10px;
  }

  .contact-details {
    width: 100% !important;
    padding: 0 15px;
  }

  .content-title {
    font-size: 24px;
  }

}

/* 小屏幕手机调整 */
@media screen and (max-width: 480px) {
  .contact-title {
    font-size: 24px;
  }

  .contact-links {
    width: 100%;
  }

  .link-item {
    padding: 12px 0;
    font-size: 12px;
  }
  .header-image{
    width:100%;
    height:auto;
    margin-top:0px;
    transform: translate(-1%, 15%) scale(1.65); /* 居中并放大 */

  }
  .contact-content{
    margin-top: 30px;
  }

}
</style>
